import { Invoice } from '@/components/ReportForm/ApReportFormInputInvoiceFileField/type';
import { useOcrContext } from '@/features/InvoiceReport/Edit/components/Context/OcrContext';
import { useCallback } from 'react';

export const useOcrFileHandler = () => {
  const { processInvoice } = useOcrContext();

  const handleFileChange = useCallback(
    async (invoice: Invoice) => {
      // Process the invoice - OcrContext will handle all invoice upload events
      await processInvoice(invoice);
    },
    [processInvoice]
  );

  return {
    handleFileChange,
  };
};
